var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filters-wrapper-main-container"},[_c('support-search-filter'),_c('support-actual-id-filter'),_c('support-entity-id-filter'),_c('support-device-id-filter'),_c('support-status-filter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }